import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './checkbox.scss';
import { useToggle } from 'hooks';
import { InputProps } from 'components/Shared/Form/input';

type AppearanceTypes = 'primary' | 'secondary' | 'tertiary';
type ColorTypes = 'grey' | 'white' | 'green' | 'charcoal';
export interface CheckboxProps extends InputProps {
  children?: ReactNode;
  appearance?: AppearanceTypes;
  color?: ColorTypes;
  label?: string;
}
export const Checkbox = ({
  checked,
  appearance = 'primary',
  color = 'grey',
  label,
  disabled,
  className,
  children,
  invalid,
  ...props
}: CheckboxProps) => {
  const [focus, setFocus] = useToggle(false);
  const onToggle = (value: boolean) => () => setFocus(value);

  return (
    <label
      className={cn(
        styles.checkbox,
        {
          [styles.checked]: checked,
          [styles.primary]: appearance === 'primary',
          [styles.secondary]: appearance === 'secondary',
          [styles.tertiary]: appearance === 'tertiary',
          [styles.grey]: color === 'grey',
          [styles.white]: color === 'white',
          [styles.green]: color === 'green',
          [styles.charcoal]: color === 'charcoal',
          [styles.focus]: focus && !disabled,
          [styles.disabled]: disabled,
          [styles.invalid]: invalid
        },
        className
      )}
      onFocus={onToggle(true)}
      onBlur={onToggle(false)}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onFocus={onToggle(true)}
        onBlur={onToggle(false)}
        {...props}
      />
      {label && <span>{label}</span>}
      {children}
    </label>
  );
};
